import { TrackingEvent } from '../types';

export function isImpressionEvent(event: TrackingEvent): event is 'Impression' {
    return event === 'Impression';
}
